import React, { useEffect, useState } from 'react';
import { useMediaQuery } from 'react-responsive';
import teacherStudying from '../../../assets/images/teacher-studyng.png';
import { Container, EmptyState, GridCard } from './styles';
import ChallengeCard from '../../../components/ChallengeCard';
import api from '../../../services/api';
import IChallengeDataProps from '../../../dtos/IChallengeDataProps';
import LoadingState from '../LoadingState';
import { ISubmissionChallengeProps } from '../../../dtos/ISubmissionChallengeProps';

interface FeedChallengeProps {
  tag: string;
}

const FeedChallenge: React.FC<FeedChallengeProps> = ({ tag }) => {
  const [challenges, setChallenges] = useState<IChallengeDataProps[]>();
  const [submissionChallenge, setSubmissionChallenge] =
    useState<ISubmissionChallengeProps[]>();
  const [isLoading, setIsLoading] = useState(false);

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' });
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' });

  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    if (isTabletOrMobile || isPortrait) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  }, [isPortrait, isTabletOrMobile]);

  useEffect(() => {
    setIsLoading(true);
    if (tag === 'available') {
      api.get('/challenges/available').then(response => {
        setChallenges(response.data);
        setIsLoading(false);
      });
    }

    if (tag === 'user') {
      api.get('/challenges/user').then(response => {
        setSubmissionChallenge(response.data);

        setIsLoading(false);
      });
    }
  }, [tag]);

  useEffect(() => {
    if (submissionChallenge) {
      const seen = new Set<string>();
      const challengesData = submissionChallenge.reduce<IChallengeDataProps[]>(
        (acc, submission) => {
          if (!seen.has(submission.challenge.id)) {
            seen.add(submission.challenge.id);
            acc.push({
              ...submission.challenge,
              status: submission.status as
                | 'no_submit'
                | 'submited'
                | 'completed',
            });
          }
          return acc;
        },
        [],
      );

      setChallenges(challengesData);
    }
  }, [submissionChallenge]);
  return (
    <Container>
      {!!isLoading && <LoadingState />}
      {!isLoading && challenges && challenges.length > 0 && (
        <GridCard>
          {challenges.map(challenge => (
            <ChallengeCard key={challenge.id} {...challenge} />
          ))}
        </GridCard>
      )}
      {!isLoading && (!challenges || challenges.length === 0) && (
        <EmptyState>
          <img src={teacherStudying} alt="teacher-studying" />
          <p>
            {tag === 'user' && (
              <>
                Nenhum desafio submetido até agora. <br />
                Crie o primeiro e compartilhe sua experiência!
              </>
            )}
            {tag === 'available' && (
              <>
                Nenhum desafio disponível no momento. <br />
                Volte mais tarde!
              </>
            )}
          </p>
        </EmptyState>
      )}
    </Container>
  );
};

export default FeedChallenge;
